<template>
  <div>
    <v-card class="rounded-lg" color="#41916b" elevation="0">
      <v-tabs v-model="tab" fixed-tabs background-color="#41916b" dark>
        <v-tabs-slider color="#086318"></v-tabs-slider>

        <v-tab>AVALIAÇÃO INICIAL - Paciente {{ patientData.name }}</v-tab>

        <v-tab-item>
          <Consentimento @changeTab="tab = $event" />
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import Consentimento from "./Consetimento-comp.vue"; 
import { mapGetters } from "vuex";
export default {
  data() {
    return {    
      tab: null, 
    };
  },

  components: {
    Consentimento, 
  },

  computed: {
    ...mapGetters({ 
      patientData: "getPatientData",
    }),
  }, 
 
};
</script>

<style scoped> 
</style>
